import { CaretDownIcon, CaretUpIcon, SquareGridFillIcon } from '@zep/icons';
import { cn } from '@zep/utils';
interface CategoryDropdownTriggerProps {
  label: string;
  isCategorySelected: boolean;
  disabled?: boolean;
  isOpen: boolean;
  onClick: () => void;
}
export const CategoryDropdownTrigger = ({
  label,
  isCategorySelected,
  disabled = false,
  isOpen = false,
  onClick
}: CategoryDropdownTriggerProps) => {
  return <button className={cn('flex items-center gap-[2px] px-[12px] py-[10px] rounded-full', 'border border-gray-200', 'text-body-2 font-medium text-gray-600', disabled ? 'bg-gray-50 text-gray-400 cursor-not-allowed' : '', !disabled && isOpen ? 'bg-gray-100' : !disabled ? 'bg-white' : '', !disabled && isCategorySelected ? 'bg-[#F3F2FF]' : '')} onClick={() => !disabled && onClick()} type="button" disabled={disabled} data-sentry-component="CategoryDropdownTrigger" data-sentry-source-file="CategoryDropdownTrigger.tsx">
      <SquareGridFillIcon className={cn('h-[12px] w-[12px]', disabled ? 'text-gray-400' : isCategorySelected ? 'text-[#6758FF]' : 'text-gray-500')} data-sentry-element="SquareGridFillIcon" data-sentry-source-file="CategoryDropdownTrigger.tsx" />
      <span className={cn('block truncate', disabled ? 'text-gray-400' : isCategorySelected ? 'text-[#6758FF]' : 'text-gray-600')}>
        {label}
      </span>
      {isOpen ? <CaretUpIcon className={cn('h-[14px] w-[14px]', isCategorySelected ? 'text-[#6758FF]' : 'text-gray-600')} /> : <CaretDownIcon className={cn('h-[14px] w-[14px]', disabled ? 'text-gray-400' : isCategorySelected ? 'text-[#6758FF]' : 'text-gray-500')} />}
    </button>;
};